import React, {PureComponent} from 'react';
import { Col, Container, Row} from 'reactstrap';
import CountofUniqueSKUs from '../Booking/components/CountofUniqueSKUs';
import FastMovingLast from '../Booking/components/FastMovingLast';
import Customizer from '../../Layout/customizer/Customizer';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import reportData from './dynamic';
import staticData from './static';
import axios from 'axios';
import Util from "../../Common/util";
import API from "../../Common/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import LoadingOverlay from 'react-loading-overlay';

var url = window.location.hostname;
var port = window.location.port;

class MISDashboard extends PureComponent{
  constructor(){
    super();
    this.state = {
      items                   : [],
      static_items            : [],
      data_render  			  : false,
      data_dynamic_render     : false,
      all_apis                : [],
      all_dynamic_apis        : []
    }
  }
  
	getListStyle = isDraggingOver => ({
    overflow: 'hidden',
	});
   
  getAllTiles = (tile_type,tile_data) => {
    var json_data = [];
    const payload = {
      "tile_type":tile_type,
        "tile_data": tile_data,
    };
    
    API.post('/reports/json_func/v1/', { param: payload })
    // axios('http://'+url+'/reports/json_func/v1/',
    // {
    //   method: 'POST',
    //   headers: {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //     'Authorization' : this.accessCookie("token")
    //   },
    //   data:{
    //     "tile_type":tile_type,
    //     "tile_data": tile_data,
    //   }
    // })
    .then((response) => {
      json_data = response.data.json_data;
    }).then((response) => {
      if(tile_type == "dynamic"){
        reportData.items = json_data;
        this.setState({
          items : reportData.items
        });
        this.DashboardCount();
      }

      if(tile_type == "static"){
        staticData.items = json_data;
        this.setState({static_items : staticData.items});
        this.StaticDashboardCount();
      }
    })
  }

  onDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    
    const items = Array.from(this.state.items);
    const [removed] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, removed);

    this.getAllTiles("dynamic",JSON.stringify(items));
    this.setState({
      items
    });
  }

  onStaticDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    
    const static_items = Array.from(this.state.static_items);
    const [removed] = static_items.splice(result.source.index, 1);
    static_items.splice(result.destination.index, 0, removed);

    this.getAllTiles("static",JSON.stringify(static_items));
    this.setState({
      static_items
    });
  }
  
  DashboardCount = () => {
    const items = this.state.items;
	  var api_count = 0
    this.state.items.map((report_obj,index) => {
      if(report_obj.show == true){
        api_count += 1;
      }
    });
	  this.state.items.map((report_obj,index) => {
      if(report_obj.show == true){
        const payload = {
          "location":this.getCookie('selectedLocation'),
            "report_type": report_obj.report_type,
            "report_detailed" : ""
        };
        
        API.post(report_obj.url, { param: payload })
        // axios('http://'+url+report_obj.url,
        // {
        //   method: 'POST',
        //   headers: {
        //     Accept: 'application/json',
        //     'Content-Type': 'application/json',
        //   },
        //   data:{
        //     "location":this.getCookie('selectedLocation'),
        //     "report_type": report_obj.report_type,
        //     "report_detailed" : ""
        //   }
        // })
        .then((response) => {
          if(response.data.count == undefined || response.data.count == "null"){
            if(response.data.sum == undefined || response.data.details == "null"){
              if(response.data.details == undefined || response.data.details == "null"){
            items[index].data_count = 0 + report_obj.data_unit;
           }else{		
            items[index].data_count = response.data.details + report_obj.data_unit;
                 }
            }else{
              items[index].data_count = response.data.sum + report_obj.data_unit;
            }
          }else{
            items[index].data_count = response.data.count + report_obj.data_unit; 
          }
        },
      (error) => {
       items[index].data_count = 0 + report_obj.data_unit;
      }).then((response) => {
          this.state.all_dynamic_apis.push(report_obj.id);
          this.setState({items});
          
          if(this.state.all_dynamic_apis.length >= api_count){
            this.setState({data_dynamic_render : true})
           } 
         
        })
     }
	  });
  }
  
  DynamicTileToggle = () => {
    this.setState({
      items : reportData.items
    });
    
    this.getAllTiles("dynamic","");
  }
   
  StaticTileToggle = () => {
    this.setState({
      static_items : staticData.items
    });
    
    this.getAllTiles("static","");
  }

  StaticDashboardCount = () => {
    const static_items = this.state.static_items;
    var api_count = 0;
    this.state.static_items.map((report_obj,index) => {
      if(report_obj.show == true){
        api_count += 1;
      }
    });
	  
	  this.state.static_items.map((report_obj,index) => {
      if(report_obj.show == true){
        const payload = {
          "location":this.getCookie('selectedLocation'),
          "report_type": report_obj.report_type,
          "report_detailed" : ""
        };
        
        API.post(report_obj.url, { param: payload })
        // axios('http://'+url+report_obj.url,
        // {
        //   method: 'POST',
        //   headers: {
        //     Accept: 'application/json',
        //     'Content-Type': 'application/json',
        //   },
        //   data:{
        //     "location":this.getCookie('selectedLocation'),
        //     "report_type": report_obj.report_type,
        //     "report_detailed" : ""
        //   }
        // })
        .then((response) => {
          if(response.data.data.length > 0){
			    if(report_obj.report_type == "PickingProductivity"){
					console.log(response.data.data);
					var last_index = response.data.data.length -1;
				  if(response.data.data[last_index].avg == undefined){
					 static_items[index].data_count = 0+ report_obj.data_unit
				  }else{
					  var avg = Math.round(response.data.data[last_index].avg,2);
					  static_items[index].data_count = avg+ report_obj.data_unit;
				  }
				}else{
		        if(response.data.data[0].count == undefined  || response.data.data[0].count == "null"){
			        if(response.data.data[0].sum == undefined  || response.data.data[0].sum == "null"){
			          if(response.data.data[0].details == undefined || response.data.data[0].details == "null"){
				          if(report_obj.report_type == "ValueInventory"){
                    static_items[index].data_count = report_obj.data_unit + " " + 0;
				          }else{
					          static_items[index].data_count = 0 + report_obj.data_unit;
				          }
			          }else{
				          if(report_obj.report_type == "ValueInventory"){
						        static_items[index].data_count =  report_obj.data_unit + " " + response.data.data[0].details;
				          }else{
					          static_items[index].data_count = response.data.data[0].details + report_obj.data_unit;
				          }
			          }
			        }else{
				        if(report_obj.report_type == "VolumeAvailable"){
						if (response.data.data[0].total_volume == undefined || response.data.data[0].total_volume == ""){
                                                    static_items[index].data_count =  response.data.data[0].sum
						}else{
					            static_items[index].data_count =  response.data.data[0].sum + " ("+response.data.data[0].total_volume+")";
						}
				        }else{
				          static_items[index].data_count = response.data.data[0].sum + report_obj.data_unit;}
			          }
	            }else{
			          if(report_obj.report_type == "ValueInventory"){
						      static_items[index].data_count =  report_obj.data_unit + " " + response.data.data[0].count; 
				        }else{
					        static_items[index].data_count = response.data.data[0].count + report_obj.data_unit; 
				        }
				}
				}
		        }else{
			        if(report_obj.report_type == "ValueInventory"){
						    static_items[index].data_count = report_obj.data_unit + " " + 0;
				      }else{
					      static_items[index].data_count = 0 + report_obj.data_unit;
				      }
		        }
          },(error) => {
            if(report_obj.report_type == "ValueInventory"){
						  static_items[index].data_count = report_obj.data_unit + " " + 0;
				    }else{
					    static_items[index].data_count = 0 + report_obj.data_unit;
				    }
      }).then((response) => {
        this.state.all_apis.push(report_obj.id);
        this.setState({static_items});
        if(this.state.all_apis.length >= api_count){
          this.setState({data_render : true})
        } 
      });
    }
    });
  }
  
  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  } 

  componentDidMount(){
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
      port = ":8088"
    }

	if (url === "localhost") {
      url= "15.206.34.41"+":8090";
    }else{
      url= window.location.hostname+port;
    }
   
    this.getAllTiles("dynamic","",1);
    this.getAllTiles("static","",1);
  }
  
  accessCookie = (cookieName) =>{
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        }
		
  render(){
	  
    return (
		
		
		
		  <Container className="dashboard">
		  
			
        {this.state.data_render ? <Customizer 
          dynamic_tile_toggle={this.DynamicTileToggle} 
          static_tile_toggle={this.StaticTileToggle} 
          static_items={this.state.static_items} items = {this.state.items}
          /> : <div></div>
        }
        <Row>
          <Col md={12}>
          <div style={{width: '50%', margin: 'auto', textAlign: 'center', marginTop: '8%'}}>
                  <div>
                   <img
                    src={require("../../../images/mis_dashboard.svg")}
                    style={{width: '60%'}}
                  ></img>
                  </div>
                  <div>
                  <img
                    src={require("../../../images/mis_image1.svg")}
                    style={{width: '48%'}}
                  ></img>
                  </div>
          </div>

          </Col>
	       
        </Row>
        
       
		
		
      
		
		  </Container>
		   
	  )
	}
}

export default MISDashboard;
